import React from 'react';
import './what-is-freshfund-judges.scss';
import FodayDumbuya from '../../images/judges/foday-dumbuya.jpg';
import PatrickBoateng from '../../images/judges/patrick-boateng.jpg';
import SharmadeanReid from '../../images/judges/sharmadean-reid.jpg';
import KwameTaylorHayford from '../../images/judges/kwame-taylor-hayford.jpg';
import PinkyCole from '../../images/judges/pinky-cole.jpg';
import FreddieHarrel from '../../images/judges/freddie-harrel.jpg';

import ExternalLink from '../Link/ExternalLink';

const WhatIsFreshFundJudgesFull = () => {
  return (
    <div className='what-is-freshfund-judges'>
      <div className='what-is-freshfund-judges__container'>
        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={FodayDumbuya} />
          </div>
          <div className='what-is-freshfund-judges__content'>
            <div className='what-is-freshfund-judge__name'>
              <h3>Foday Dumbuya</h3>
            </div>
            <div className='what-is-freshfund-judge__region'>UK Judge</div>
            <div className='what-is-freshfund-judge__bio'>
              Founder, creative director and designer of menswear brand Labrum London. Originally
              from Sierra Leone, Foday reflects his journey from working-class upbringing to
              positions at DKNY and Nike through Labrum. The company started from his living room
              with an aim to make practical, utilitarian clothing based on simplicity, fit and great
              design.
            </div>
            <div className='what-is-freshfund-judge__social'>
              <ExternalLink href='https://instagram.com/labrumlondon'>@labrumlondon</ExternalLink>
            </div>
          </div>
        </div>

        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={PatrickBoateng} />
          </div>
          <div className='what-is-freshfund-judge__name'>
            <h3>Patrick Boateng</h3>
          </div>
          <div className='what-is-freshfund-judge__region'>US Judge</div>
          <div className='what-is-freshfund-judge__bio'>
            Founder and CEO of Ceylon by Anim Labs, a skincare brand for men of color. A former US
            diplomat, he transformed his personal skin struggles into a scientifically backed
            solution for men like him. Patrick draws inspiration from his experiences exploring the
            intersection of culture, health and technology.
          </div>
          <div className='what-is-freshfund-judge__social'>
            <ExternalLink href='https://instagram.com/ceylonskincare'>@ceylonskincare</ExternalLink>
          </div>
        </div>
        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={SharmadeanReid} />
          </div>
          <div className='what-is-freshfund-judge__name'>
            <h3>Sharmadean Reid</h3>
          </div>
          <div className='what-is-freshfund-judge__region'>UK Judge</div>
          <div className='what-is-freshfund-judge__bio'>
            Founder and CEO of Beautystack and The Stack World. Originally a fashion communications
            graduate at Central Saint Martins, Sharmadean moved on to become a brand consultant and
            fashion stylist for Nike, Asos and Arena HOMME+. Her career spans everything from
            authorship and the founding of a magazine to salon ownership and beauty industry
            advocacy.
          </div>
          <div className='what-is-freshfund-judge__social'>
            <ExternalLink href='https://instagram.com/thestack.world'>@thestack.world</ExternalLink>
          </div>
        </div>
        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={KwameTaylorHayford} />
          </div>
          <div className='what-is-freshfund-judge__name'>
            <h3>Kwame Taylor-Hayford</h3>
          </div>
          <div className='what-is-freshfund-judge__region'>US Judge</div>
          <div className='what-is-freshfund-judge__bio'>
            Co-founder of Kin, a creative consultancy and agency in Brooklyn. Before launching Kin,
            Kwame was managing director of brand at Chobani, and had previously held roles at Sid
            Lee, Anomaly and Saatchi & Saatchi. He’s also the co-founder of Saturday Morning, a
            non-profit that aims to raise awareness of racial bias and injustice.
          </div>
          <div className='what-is-freshfund-judge__social'>
            <ExternalLink href='https://instagram.com/workwithkin'>@workwithkin</ExternalLink>
          </div>
        </div>

        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={PinkyCole} />
          </div>
          <div className='what-is-freshfund-judge__name'>
            <h3>Pinky Cole</h3>
          </div>
          <div className='what-is-freshfund-judge__region'>US Judge</div>
          <div className='what-is-freshfund-judge__bio'>
            Founder of Slutty Vegan, the ever-popular plant-based restaurant brand with locations
            across Atlanta. A former TV producer, she is also a community leader and started The
            Pinky Cole Foundation, which promotes black economic progress with educational programs
            to help young adults to become entrepreneurs.
          </div>
          <div className='what-is-freshfund-judge__social'>
            <ExternalLink href='https://instagram.com/sluttyveganatl'>@sluttyveganatl</ExternalLink>
          </div>
        </div>
        <div className='what-is-freshfund-judge'>
          <div className='what-is-freshfund-judge__image'>
            <img src={FreddieHarrel} />
          </div>
          <div className='what-is-freshfund-judge__name'>
            <h3>Freddie Harrel</h3>
          </div>
          <div className='what-is-freshfund-judge__region'>UK Judge</div>
          <div className='what-is-freshfund-judge__bio'>
            Founder of RadSwan, a premium synthetic wig brand. She’s also a blogger, lifestyle
            influencer – she was named Cosmopolitan’s Influencer of the Year in 2018 – and
            storyteller. Before launching RadSwan, Freddy hosted confidence workshops through SHE
            Unleashed and spent time as a digital strategist working with ASOS, Vestiaire Collective
            and Topshop.
          </div>
          <div className='what-is-freshfund-judge__social'>
            <ExternalLink href='https://instagram.com/radswan'>@radswan</ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatIsFreshFundJudgesFull;
